// Keeps the focused input visible when the mobile keyboard opens.
if (typeof window !== "undefined") {
  window.addEventListener("focusin", (e) => {
    const el = e.target;
    if (el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.tagName === "SELECT")) {
      setTimeout(() => {
        try { el.scrollIntoView({ block: "center", behavior: "smooth" }); } catch { /* noop */ }
      }, 300);
    }
  });
}
